import React from 'react';

import { CmButton, CmFlex, CmHeading, CmText } from '@/components/uiParts';

const PageNotFoundPage = (): JSX.Element => {
  return (
    <CmFlex direction="column" align="center" justify="center" height="100%">
      <CmHeading mb={2} as="h1" size="xl">
        404
      </CmHeading>
      <CmText mb={12}>ページが見つかりませんでした</CmText>
      {/*
       // @ts-ignore TS2590 */}
      <CmButton
        colorScheme="black"
        variant="link"
        onClick={() => {
          location.href = '/';
        }}
      >
        トップに戻る
      </CmButton>
    </CmFlex>
  );
};
export default PageNotFoundPage;
